const DESKTOP_MIN_WIDTH = 1161;
const WRAP_CLASS = "header--nav-wraps";

class HeaderNavFit {
  constructor(header) {
    this.header = header;
    this.left = header.querySelector(".header__left");
    this.nav = header.querySelector(".header__main-nav");
    this.items = this.nav && this.nav.querySelector(".header__main-nav-items");
    this.search = this.left && this.left.querySelector("header-search");

    if (!this.left || !this.nav || !this.items) return;

    this.frame = null;
    this.schedule = this.schedule.bind(this);

    window.addEventListener("resize", this.schedule);
    window.addEventListener("orientationchange", this.schedule);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(this.schedule);
    }

    this.update();
  }

  schedule() {
    if (this.frame) return;
    this.frame = window.requestAnimationFrame(() => {
      this.frame = null;
      this.update();
    });
  }

  get _isWrapped() {
    return this.header.classList.contains(WRAP_CLASS);
  }

  _requiredWidth() {
    const clone = this.items.cloneNode(true);

    clone.querySelectorAll(".mega-menu").forEach((el) => el.remove());
    clone.style.cssText =
      "position:absolute;top:0;left:0;visibility:hidden;pointer-events:none;flex-wrap:nowrap;width:max-content;";

    this.header.appendChild(clone);
    const width = clone.getBoundingClientRect().width;
    clone.remove();

    return width;
  }

  _measure() {
    const wasWrapped = this._isWrapped;

    if (wasWrapped) {
      this.header.classList.remove(WRAP_CLASS);
    }

    const gap = parseFloat(window.getComputedStyle(this.left).columnGap) || 0;
    const searchWidth = this.search ? this.search.offsetWidth : 0;
    const available = this.left.clientWidth - searchWidth - gap;
    const required = this._requiredWidth();

    if (wasWrapped) {
      this.header.classList.add(WRAP_CLASS);
    }

    return { required, available };
  }

  _publishHeaderHeight() {
    window.requestAnimationFrame(() => {
      document.documentElement.style.setProperty(
        "--header-height",
        `${this.header.getBoundingClientRect().height}px`,
      );
    });
  }

  update() {
    if (window.innerWidth < DESKTOP_MIN_WIDTH) {
      this.header.classList.remove(WRAP_CLASS);
      this._publishHeaderHeight();
      return;
    }

    const { required, available } = this._measure();

    this.header.classList.toggle(WRAP_CLASS, required > available);
    this._publishHeaderHeight();
  }
}

const init = () => {
  document.querySelectorAll(".header").forEach((header) => {
    if (header.dataset.navFit) return;
    header.dataset.navFit = "true";
    new HeaderNavFit(header);
  });
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
